module.exports = __webpack_public_path__ + "media/video-paperclicks-mobile.1382ea9a.mp4";